import { render } from "./SettingCuti.vue?vue&type=template&id=42aa4be2"
import script from "./SettingCuti.vue?vue&type=script&lang=js"
export * from "./SettingCuti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__